import React from 'react';
import StatusPill, { type StatusColorVariant } from '../common/StatusPill';

export type ChildAccountStatusType =
  | 'pending'
  | 'provisioning'
  | 'configuring'
  | 'ready'
  | 'pending-decommissioning'
  | 'decommissioning'
  | 'decommissioned'
  | 'error';

interface ChildAccountStatusProps {
  status: string;
  className?: string;
}

const ChildAccountStatus: React.FC<ChildAccountStatusProps> = ({ status, className = '' }) => {
  const normalizedStatus = status.toLowerCase() as ChildAccountStatusType;

  const getStatusColorVariant = (status: ChildAccountStatusType): StatusColorVariant => {
    switch (status) {
      case 'ready':
        return 'success';
      case 'error':
        return 'error';
      case 'decommissioned':
        return 'dark';
      case 'decommissioning':
      case 'pending-decommissioning':
        return 'neutral';
      case 'pending':
      case 'provisioning':
      case 'configuring':
        return 'warning-stripes';
      default:
        return 'neutral';
    }
  };

  const getStatusText = (status: string): string => {
    const normalizedStatus = status.toLowerCase() as ChildAccountStatusType;

    if (normalizedStatus === 'pending-decommissioning') {
      return 'Pending Decommissioning';
    }

    return normalizedStatus
      .split('-')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  return (
    <StatusPill
      status={normalizedStatus}
      colorVariant={getStatusColorVariant(normalizedStatus)}
      textTransform={getStatusText}
      className={className}
    />
  );
};

export default ChildAccountStatus;
